'use strict';

module.exports = function ($uibModal, dialog, Department, $stateParams, $state, teams, team, $scope) {
    var _this = this;

    this.team = team;

    this.addUsers = function () {
        $uibModal.open({
            animation: true,
            controller: ['$uibModalInstance', '$stateParams', 'Department', 'currentTeamMembers',
                function ($uibModalInstance, $stateParams, Department, currentTeamMembers) {
                    this.members = [];
                    this.currentTeamMembers = currentTeamMembers;
                    var _this = this;
                    this.loading = false;
                    this.isTeamLeader = false;

                    this.addUsers = function () {
                        if (!_this.members.length) {
                            return;
                        }

                        this.loading = true;
                        Department.addTeamMember({
                            departmentId: $stateParams.departmentId,
                            teamId: $stateParams.teamId

                        }, {
                            ids: _this.members.map(function (member) {
                                return member.id;
                            }),
                            isTeamLeader: _this.isTeamLeader
                        })
                            .$promise
                            .then(function (member) {
                                $uibModalInstance.close(member.response);
                            })
                            .catch(function (error) {
                                this.loading = false;
                                console.log(error);
                            });
                    };

                    this.checkTeamLeader = function () {
                        // console.log('_this.isTeamLeader1', _this.isTeamLeader);
                        _this.isTeamLeader = !_this.isTeamLeader;
                    }
                }
            ],
            templateUrl: 'dashboard-team/dashboardAddUsersModal.html',
            controllerAs: 'modal',
            size: 'md',
            windowClass: 'dialog',
            bindToController: true,
            resolve: {
                currentTeamMembers: function () {
                    return _this.team.members || [];
                }
            }
        }).result.then(function (members) {
            _this.team.members = _this.team.members.concat(members);
        });
    };

    $scope.$watch(function () {
        return _this.team.members;
    }, function () {
        teams.forEach(function (team) {
            if (team.id === _this.team.id) {
                team.members = _this.team.members;
            }
        });
    }, true);

};
